<div
  style="
    background: linear-gradient(
        to right bottom,
        rgba(0, 0, 0, 0.7),
        rgba(0, 0, 0, 0.7)
      ),
      url('assets/home-page.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  "
  class="py-8 sm:py-12 md:py-16 lg:py-20 px-4 sm:px-6 md:px-8"
>
  <div class="relative max-w-3xl mx-auto text-center">
    <h1
      class="mt-2 sm:mt-4 md:mt-6 text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight sm:leading-tight md:leading-none tracking-tight font-bold text-white px-2"
    >
      Your Gateway To Unrivaled Experiences
    </h1>
    <p class="my-4 sm:my-5 md:my-6 text-base sm:text-lg text-slate-200 px-2 max-w-2xl mx-auto">
      Buy, Sell, and Share Tickets with a Vibrant Community of Event Lovers.
    </p>

    <hypenation-tickets-filter-bar
      class="my-4 sm:my-5 md:my-6"
      (seachString)="applyFilters($event)"
    ></hypenation-tickets-filter-bar>
  </div>
</div>

<div class="container mx-auto p-4">
  <hypenation-tickets-featured-events-carousel *ngIf="featuredEvents().length > 0"
    [events]="featuredEvents()"
    [loading]="featuredEventsLoading()"
  ></hypenation-tickets-featured-events-carousel>

  <div #activeSection>
    <hypenation-tickets-events-list
      title="Active Events"
      [totalItems]="totalItems()"
      [events]="events()"
      [loading]="eventsLoading()"
      [showFiltering]="true"
      [eventsTypes]="eventsTypes()"
      loadMode="button"
      [hasMore]="hasMore()"
      [loadingMore]="loadingMore()"
      (loadMore)="loadMoreActive()"
      (selectEventCategory)="filterByCategory($event.name)"
      (clearFilter)="clearCategoryFilter()"
    ></hypenation-tickets-events-list>
  </div>
  <hypenation-tickets-events-list *ngIf="comingSoonEvents().length > 0"
    title="Coming Soon"
    [totalItems]="comingSoonTotalItems()"
    [events]="comingSoonEvents()"
    [loading]="comingSoonLoading()"
    loadMode="button"
    [hasMore]="comingSoonHasMore()"
    [loadingMore]="comingSoonLoadingMore()"
    (loadMore)="loadMoreComingSoon()"
  ></hypenation-tickets-events-list>
  <hypenation-tickets-events-list
    title="Past Events"
    [totalItems]="pastEventsTotalItems()"
    [events]="pastEvents()"
    [loading]="pastEventsLoading()"
    loadMode="auto"
    [hasMore]="pastEventsHasMore()"
    [loadingMore]="pastEventsLoadingMore()"
    (loadMore)="loadMorePastEvents()"
  ></hypenation-tickets-events-list>
</div>
